import { Component, Input, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.css']
})
export class AudioPlayerComponent implements OnInit, OnDestroy {
  @Input() src!: string; // URL del audio

  audio!: HTMLAudioElement;
  isPlaying = false;
  currentTime = 0;
  duration = 0;
  interval: any;

  ngOnInit() {
    this.audio = new Audio(this.src);
    this.audio.volume = 0.4;
    // this.audio.playbackRate = 0.5;
    this.audio.addEventListener('loadedmetadata', () => {
      this.duration = this.audio.duration;
    });

    this.audio.addEventListener('timeupdate', () => {
      this.currentTime = this.audio.currentTime;
    });

    this.audio.addEventListener('ended', () => {
      this.isPlaying = false;
      this.currentTime = 0;
    });
  }

  togglePlay() {
    if (this.isPlaying) {
      this.audio.pause();
    } else {
      this.audio.play();
    }
    this.isPlaying = !this.isPlaying;
  }

  formatTime(time: number): string {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  }

  ngOnDestroy() {
    console.log("ngOnDestroy audio-playes.component");
    if (this.audio) {
      this.audio.pause();
      this.audio.src = '';
    }
  }
}
